import ItemWrapper from '@/src/components/Layouts/Item/Item';
import React from 'react';
import { Form } from 'src/components/Antd';
import { RegisteredSalesChannel } from 'src/constrains/AdvancedFilters/Components';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/CustomerDatabaseConfig/CustomerTag/Detail/Filters/Components/SectionWrapper';
import { i18nGet } from 'src/tools/tools';
import { Clear } from '../Components';
const Item = Form.Item;

export enum EExportType {
  All = 'All',
  Any = 'Any',
}
const _RegisteredSalesChannel = (props) => {
  const { form, name, root, state, radioName, options, disabled } = props;
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <SectionWrapper
      title={getI18n(
        'customerTag.registeredSalesChannel.registeredsaleschannel',
      )}>
      <ItemWrapper title=''>
        <RegisteredSalesChannel
          disabled={disabled}
          name={name}
          radioName={radioName}
          options={options}
        />
        <Item
          shouldUpdate={(p, c) => {
            const touched = form.isFieldTouched(root);
            return touched; //|| cv !== pv;
          }}>
          {(f) => {
            const { getFieldValue } = f;
            const hasValue = getFieldValue(radioName);
            if (hasValue) {
              return (
                <Clear
                  disabled={disabled}
                  onClick={() => {
                    form.setFieldsValue(state);
                  }}
                />
              );
            }
          }}
        </Item>
      </ItemWrapper>
    </SectionWrapper>
  );
};
export default _RegisteredSalesChannel;
